import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, timer, Subscription } from 'rxjs';
import { ScreeningReport } from '../models/screening-report.model';
import { SurveyService } from '../services/survey.service';
import { LocalstorageService } from '../services/localstorage.service';
import { QuestionTranformationService } from '../services/question-tranformation.service';

const EXPIRYTHRESHHOLD = 43200; //12 hours

@Component({
  selector: 'app-monkeypox-report',
  templateUrl: './monkeypox-report.component.html',
  styleUrls: ['./monkeypox-report.component.css']
})
export class MonkeypoxReportComponent implements OnInit {
  screeningReportModel: ScreeningReport;

  get hideNewScreeningButton(){
    if(this.screeningReportModel){
      return this.screeningReportModel.resultType == 'Invalid' || this.screeningReportModel.resultType == 'Fail'
    }
  }

  constructor(private router: Router,
    private surveyService: SurveyService,
    private localstorageService: LocalstorageService,
    private tranformationService: QuestionTranformationService){}
 
  async ngOnInit() {
    this.screeningReportModel = new ScreeningReport();
    let authDetails = this.localstorageService.getAuth();

    //await this.tranformationService.loadDynamicQuestionTexts(authDetails.employeeInfo.corpId);
    
    this.surveyService.getMonkeypoxReport(authDetails.employeeInfo.corpId).subscribe(responseData =>{
      this.screeningReportModel = responseData;
      //this.screeningReportModel.message = this.tranformationService.replaceIntTravelCovidTestingDate(this.screeningReportModel.message);
    }, error=> console.log(error));
    
  }

  startNewScreening(){
    this.router.navigateByUrl('/survey/monkeypox');
  }

  //startMonkeypoxScreening(){
  //  this.router.navigateByUrl('/covid-exposure');
  //}
}
